module.exports = __webpack_public_path__ + "assets/certificate_pdf/Big Data Knowledge Today_Silicon Stone Education_20180718.5d500300.pdf";